import { TASK_LABEL_PALETTE } from '../types/kanban';

export const getLabelChipStyle = (
  colorHex: string
): { backgroundColor: string; color: string } => ({
  backgroundColor: `${colorHex}22`,
  color: colorHex,
});

/** Pick a color from the last third of the palette (design: indices ~15–20). */
export const pickNewLabelColor = (palette: string[] = [...TASK_LABEL_PALETTE]): string => {
  if (palette.length === 0) return '#1E88E5';
  const rangeStart = Math.floor(palette.length * 0.7);
  const index = rangeStart + Math.floor(Math.random() * (palette.length - rangeStart));
  return palette[index] ?? palette[palette.length - 1];
};

export const normalizeLabelName = (name: string): string => name.trim();
